import { useEffect, useRef } from 'react'

export function useInterval(callback: () => void, delay: number | null) {
  // preserve value between renders
  const savedCallback = useRef<() => void>(callback)

  useEffect(() => {
    // When the delay is not set, we don't set the interval
    if (!delay && delay !== 0) {
      return
    }

    const id = setInterval(() => savedCallback.current(), delay)

    return () => clearInterval(id)
  }, [delay])
}
